<app-page>
  <settings></settings>
</app-page>
